import { useTranslation } from 'react-i18next';
import React, { useCallback, useState, useMemo } from 'react';

import { trim } from 'lodash';
import style from './index.module.scss';
import { Button, AutoSizeTextarea } from '@/components';
import { useGroupProposalCreate } from '@/views/GroupProposal/hooks/create';

import cx from 'clsx';
import { useCurrentAddressInfo } from '@/hooks';

type ModalProps = {
  hide(): void;
  groupId: number;
};

const INPUT_LIMIT = 100;

export const ApplyToJoinGroupModal = ({ hide, groupId }: ModalProps) => {
  const { t } = useTranslation();

  const [value, setValue] = useState('');
  const { address } = useCurrentAddressInfo();
  const { mutateAsync, isLoading } = useGroupProposalCreate(groupId);
  const isExceedLength = useMemo(() => !!value && value.length > INPUT_LIMIT, [value]);
  const handleChange = useCallback((value: string) => {
    setValue(value);
  }, []);

  const onConfirm = useCallback(async () => {
    const newValue = trim(value).replace(/\n+/g, '\n');
    const res = await mutateAsync({
      type: 'apply_join',
      data: {
        user_id: address,
        comment: newValue,
      },
    });
    if (res?.proposal) {
      hide();
    }
  }, [address, hide, mutateAsync, value]);

  const isDisabled = useMemo(() => !value || isExceedLength, [value, isExceedLength]);

  return (
    <div className={style.joinGroupModal}>
      <div className={style.header}>{t('GroupModalManager_ApplyToJoinGroupModal.rvjxcd')}</div>
      <div className={style.subTitle}>{t('GroupModalManager_ApplyToJoinGroupModal.zmbgsx')}</div>

      <AutoSizeTextarea
        placeholder={t('GroupModalManager_ApplyToJoinGroupModal.placeholder', {
          amount: INPUT_LIMIT,
        })}
        value={value}
        className={cx(style.textarea)}
        onChange={handleChange}
        rows={4}
        maxRows={4}
      />
      <div className={cx(style.maxLength)}>
        <span className={cx(isExceedLength && style.exceedLength)}>{value?.length ?? 0}</span>/
        {INPUT_LIMIT}
      </div>
      <div className={style.buttons}>
        <Button
          type="primary"
          className={style.button}
          loading={isLoading}
          onClick={onConfirm}
          disabled={isDisabled}>
          {t('GroupModalManager_ApplyToJoinGroupModal.11sitq')}
        </Button>
      </div>
    </div>
  );
};
